<template lang="pug">
#right-click-menu(
  ref='rightMenu', v-if='rightMenuVisible',
  @blur='closeRightClickMenu',
  :style='{ top:top, left:left }'
)
  p.right-click-menu-item(id="RightClickDesktopMenu-edit", @click.stop="rightClickDesktopAction('editDevice', rightClickedItem )")
    font-awesome-icon.icon(icon="edit")
    span &nbsp; {{ $t('Edit') }}
  p.right-click-menu-parent(
    id="RightClickDesktopMenu-copy",
    @mouseover="displaySection = 'copy'",
    @mouseleave="displaySection = undefined",
    @click.stop=""
  )
    font-awesome-icon.icon(icon="copy")
    span &nbsp; {{ $t('Copy') }}
    font-awesome-icon.icon.float-right(icon="chevron-right")
    section.sub-menu.sub-menu-left(v-if="displaySection === 'copy'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
      p.right-click-menu-item(
        @click.stop="rightClickDesktopAction('copyTags', rightClickedItem )",
        id="RightClickDesktopMenu-copyTags"
      )
        font-awesome-icon.icon(icon="tags")
        span &nbsp; {{ $t(`Tags`) }}
      p.right-click-menu-item(
        @click.stop="rightClickDesktopAction('copyTimeRestrictions', rightClickedItem )",
        id="RightClickDesktopMenu-copyTimeRestrictions",
        :class="{ disabled: !(rightClickedItem.Device_DateRestrictions.length > 0 || rightClickedItem.Device_DaytimeRestrictions.length > 0) }"
      )
        font-awesome-icon.icon(icon="clock")
        span &nbsp; {{ $t('Time restrictions') }}
  p.right-click-menu-parent(
    id="RightClickDesktopMenu-paste",
    @mouseover="displaySection = 'paste'",
    @mouseleave="displaySection = undefined",
    @click.stop=""
  )
    font-awesome-icon.icon(icon="paste")
    span &nbsp; {{ $t('Paste') }}
    font-awesome-icon.icon.float-right(icon="chevron-right")
    section.sub-menu.sub-menu-left(v-if="displaySection === 'paste'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
      p.right-click-menu-item(
        id="RightClickDesktopMenu-pasteTags",
        @click.stop="rightClickDesktopAction('pasteTags')",
        :class="{ disabled: !($store.state.Clipboard.copied_device_tags.length > 0) }"
      )
        font-awesome-icon.icon(icon="tags")
        span &nbsp; {{ $t(`Paste tags`) }}
      p.right-click-menu-item(
        id="RightClickDesktopMenu-pasteTimeRestrictions",
        @click.stop="rightClickDesktopAction('pasteTimeRestrictions')",
        :class="{ disabled: !($store.state.Clipboard.copied_device_daytime_restrictions.length > 0 || $store.state.Clipboard.copied_device_date_restrictions.length > 0) }"
      )
        font-awesome-icon.icon(icon="clock")
        span &nbsp; {{ $t(`Paste time restrictions`) }}
  p.right-click-menu-parent(
    id="RightClickDesktopMenu-update",
    @mouseover="displaySection = 'update'",
    @mouseleave="displaySection = undefined",
    @click.stop=""
  )
    font-awesome-icon.icon(icon="share")
    span &nbsp; {{ $t('Update') }}
    font-awesome-icon.icon.float-right(icon="chevron-right")
    section.sub-menu.sub-menu-left(v-if="displaySection === 'update'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
      p.right-click-menu-item(
        id="RightClickDesktopMenu-updateContents",
        @click.stop="rightClickDesktopAction('updateContents')",
        :class="{ disabled: !(modificationsInSelected > 0) }"
      )
        font-awesome-icon.icon(icon="upload")
        span &nbsp; {{ $t(`Content`) }} &nbsp;
        font-awesome-icon(icon="share")
      p.right-click-menu-item(
        v-if="isAdminOrSuperAdmin || isManager",
        id="RightClickDesktopMenu-updateContents",
        @click.stop="rightClickDesktopAction('resendContents')",
      )
        font-awesome-icon.icon(icon="upload")
        span &nbsp; {{ $t(`Resend Last Content`) }} &nbsp;
        font-awesome-icon(icon="share")
      p.right-click-menu-item(id="RightClickDesktopMenu-updateSchedule", @click.stop="rightClickDesktopAction('updateSchedules')")
        font-awesome-icon.icon(icon="calendar-alt")
        span &nbsp; {{ $t('Schedule') }} &nbsp;
      p.right-click-menu-item(id="RightClickDesktopMenu-updateScreenshot", @click.stop="rightClickDesktopAction('requestScreenshots')")
        font-awesome-icon.icon(icon="image")
        span &nbsp; {{ $t('Screenshot') }} &nbsp;
  p.right-click-menu-parent(
    id="RightClickDesktopMenu-restart",
    @mouseover="displaySection = 'restart'",
    @mouseleave="displaySection = undefined",
    @click.stop=""
  )
    font-awesome-icon.icon(icon="sync")
    span &nbsp; {{ $t('Restart') }}
    font-awesome-icon.icon.float-right(icon="chevron-right")
    section.sub-menu.sub-menu-left(v-if="displaySection === 'restart'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
      p.right-click-menu-item(id="RightClickDesktopMenu-restartRenderer", @click.stop="rightClickDesktopAction('restartRenderers')")
        font-awesome-icon.icon(icon="sync")
        span &nbsp; {{ $t('Restart renderer') }}
      p.right-click-menu-item(v-if='userHasCoreOSPrivilege', id="RightClickDesktopMenu-restartCore", @click.stop="rightClickDesktopAction('restartDevicesCore')")
        font-awesome-icon.icon(icon="sync")
        span &nbsp; {{ $t('Restart core') }}
      p.right-click-menu-item(v-if='userHasCoreOSPrivilege', id="RightClickDesktopMenu-restartOS", @click.stop="rightClickDesktopAction('restartDevicesOS')")
        font-awesome-icon.icon(icon="sync")
        span &nbsp; {{ $t('Restart OS') }}
  p.right-click-menu-parent(
    id="RightClickDesktopMenu-clear",
    @mouseover="displaySection = 'clear'",
    @mouseleave="displaySection = undefined",
    @click.stop=""
  )
    font-awesome-icon.icon(icon="trash")
    span &nbsp; {{ $t('Clear') }}
    font-awesome-icon.icon.float-right(icon="chevron-right")
    section.sub-menu.sub-menu-left(v-if="displaySection === 'clear'"
        :class="{'sub-menu-right': rightFreeSpace > 500 }"
      )
      p.right-click-menu-item(id="RightClickDesktopMenu-clearContents", @click.stop="rightClickDesktopAction('purgeContents')")
        font-awesome-icon.icon(icon="upload")
        span &nbsp; {{ $t('Content') }}
      p.right-click-menu-item(id="RightClickDesktopMenu-clearTags", @click.stop="rightClickDesktopAction('clearTags')")
        font-awesome-icon.icon(icon="tags")
        span &nbsp; {{ $t('Tags') }}
      p.right-click-menu-item(id="RightClickDesktopMenu-clearTime restrictions", @click.stop="rightClickDesktopAction('clearTimeRestrictions')")
        font-awesome-icon.icon(icon="clock")
        span &nbsp; {{ $t('Time restrictions') }}
  p.right-click-menu-item(id="RightClickDesktopMenu-setLocation", @click.stop="rightClickDesktopAction('addToLocation')")
    font-awesome-icon.icon(icon="chalkboard-teacher")
    span &nbsp; {{ $t('Set location') }}
  p.right-click-menu-item(id="RightClickDesktopMenu-showPlaylog", @click.stop="rightClickDesktopAction('showPlaylogDevice', rightClickedItem)")
    font-awesome-icon.icon(icon="bars")
    span &nbsp; {{ $t('Show Playlog') }}
  p.right-click-menu-item(id="RightClickDesktopMenu-removeFrom", v-if='$parent.desktopGroup', @click.stop="rightClickDesktopAction('removeFromGroup')")
    font-awesome-icon.icon(icon="ban")
    span &nbsp; {{ $t('Remove from group ') }} {{ $parent.desktopGroup.name }}
  p.right-click-menu-item(id="RightClickDesktopMenu-identifyDevice", @click.stop="rightClickDesktopAction('identifyDevices')")
    font-awesome-icon.icon(icon="barcode")
    span &nbsp; {{ $t('Display onscreen info') }} &nbsp;
  p.right-click-menu-item(id="RightClickDesktopMenu-identifyDevice", @click.stop="rightClickDesktopAction('destroyDevices')",
  v-if='this.$store.state.User.user.userPrivileges.filter(up => up.entity === "device" && up.method === "DELETE")')
    font-awesome-icon.icon(icon="trash")
    span &nbsp; {{ $t('Delete') }} &nbsp;
</template>

<script>
import Vue from 'vue'
import MediumIcon from '../Common/MediumIcon'
import mediaUtilsMixin from '../Common/mediaUtils.mixin'
import textUtilsMixin from '../Common/textUtils.mixin'
import userUtilsMixin from '../Common/userUtils.mixin'

export default {
  props: [],
  mixins: [mediaUtilsMixin, textUtilsMixin, userUtilsMixin],
  components: {
    MediumIcon
  },
  created () {
  },
  watch: {
    variableName: async (newVal, oldVal) => {
    }
  },
  data () {
    return {
      errors: {
      },
      rightMenuVisible: false,
      top: '0px',
      left: '0px',
      rightClickedItem: undefined,
      displaySection: undefined
    }
  },
  methods: {
    rightClickDesktopAction (action, desktop) {
      if (!this.rightMenuVisible) return
      if (action === 'updateContents' && !(this.modificationsInSelected > 0)) return
      this.$emit('rightClickAction', { action, desktop })
      this.closeRightClickMenu()
    },
    // RIGHT-CLICK
    setRightClickMenuPosition (top, left) {
      const largestHeight = window.innerHeight - this.$refs.rightMenu.offsetHeight - 25
      const largestWidth = window.innerWidth - this.$refs.rightMenu.offsetWidth - 25

      if (top > largestHeight) top = largestHeight

      if (left > largestWidth) left = largestWidth

      this.top = top + 'px'
      this.left = left + 'px'
    },
    closeRightClickMenu () {
      this.displaySection = undefined
      this.rightMenuVisible = false
      this.rightClickedItem = undefined
    },
    async openRightClickMenu (item, $event) {
      $event.preventDefault()
      const deviceDeviceDateRestrictions = await Vue.axios
        .get(`Device_DateRestriction?Device=${item.Device.id}`)
        .then(response => {
          return response.data
        })
      const deviceDaytimeRestrictions = await Vue.axios
        .get(`Device_DaytimeRestriction?Device=${item.Device.id}`)
        .then(response => {
          return response.data
        })
      if (!$event.ctrlKey && !$event.metaKey && !this.desktopsSelected.find(ds => ds.id === item.id)) {
        this.$store.commit('Device/CLEAR_DESKTOPS_SELECTED_RIGHT')
      }
      if (this.desktopsSelected.findIndex(dktp => dktp.id === item.id) === -1) {
        this.$store.commit('Device/ADD_DESKTOPS_SELECTED_RIGHT', [...this.desktopsSelected, item])
      }
      this.rightClickedItem = item
      this.rightClickedItem.Device_DateRestrictions = deviceDeviceDateRestrictions
      this.rightClickedItem.Device_DaytimeRestrictions = deviceDaytimeRestrictions
      this.rightMenuVisible = true
      Vue.nextTick(() => {
        this.setRightClickMenuPosition($event.y, $event.x)
      })
    }
  },
  computed: {
    desktopsSelected () {
      return this.$store.state.Device.desktops_selected_right
    },
    modificationsInSelected () {
      const affectedIds = this.$store.state.Device.desktops_affected.map(da => da.Medium.id)
      const selectedIds = this.$store.state.Device.desktops_selected_right.map(dsr => dsr.LocalPlayList)
      const intersection = affectedIds.filter(id => selectedIds.includes(id))
      return intersection.length
    },
    userRoleNames () {
      return this.$store.state.User.user.Roles.map(role => role.name)
    },
    userHasCoreOSPrivilege () {
      return this.userRoleNames.includes('superadministrator') ||
      this.userRoleNames.includes('administrator') ||
      this.userRoleNames.includes('manager')
    },
    rightFreeSpace () {
      return window.innerWidth - parseInt(this.left.replace('px', ''))
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
@import "../Common/rightClick.scss";
</style>



// WEBPACK FOOTER //
// src/components/Device/RightClickDesktopMenu.vue